export function chance(c) {
  return Math.random(1) < c;
}

export function randomn(n) {
  return Math.floor(Math.random() * n);
}

export function randomr(f, t) {
  return f + randomn(t - f);
}

export function getBrightness(r, g, b) {
  if (r + g + b === 0) return 0;
  return Math.floor(Math.sqrt(0.299 * r * r + 0.587 * g * g + 0.114 * b * b));
}

export function randomElem(arr, lng = arr.length) {
  return arr[Math.floor(Math.random() * lng)];
}

export function constrain(value, min, max) {
  return value < min ? min : value > max ? max : value;
}

export function map(value, start1, stop1, start2, stop2) {
  return ((value - start1) / (stop1 - start1)) * (stop2 - start2) + start2;
}

export function fmap(p, bs, be, ds, de) {
  return ds > de
    ? constrain(map(p, be, bs, de, ds), de, ds)
    : constrain(map(p, bs, be, ds, de), ds, de);
}

export function greyscale(src, min = 0, max = 255) {
  for (let i = 0; i < src.length / 4; i++) {
    let ind = i * 4;
    let b = getBrightness(src[ind], src[ind + 1], src[ind + 2]);
    b = Math.floor(fmap(b, min, max, 0, 255));
    src[i * 4] = b;
    src[i * 4 + 1] = b;
    src[i * 4 + 2] = b;
    src[i * 4 + 3] = 255;
  }
}

export function gradientMap(src, palette) {
  for (let i = 0; i < src.length / 4; i++) {
    let ind = i * 4;
    let b = src[ind] / 255.0;
    let c = palette[Math.floor(b * (palette.length - 1))];
    src[ind] = c[0];
    src[ind + 1] = c[1];
    src[ind + 2] = c[2];
    src[ind + 3] = 255;
  }
}

export function eased(f, t, e) {
  if (Math.abs(t - f) < 0.001) return t;
  return f + (t - f) * e;
}

export function mod(n, m) {
  return Math.floor((n % m) + m) % m;
}

export function beziered(v, pow, p, c1, c2, A, B) {
  let e = v % p;
  let b = v - e;
  e /= p;
  e = constrain(map(e, c1, c2, 0, 1), 0, 1);
  let n = 3 * (1 - e) * (1 - e) * e * A + 3 * (1 - e) * e * e * B + e * e * e;
  let result = b + n * p;
  if (pow == 0) return result;
  else return beziered(result, pow - 1, p, 0, 1, A, B);
}
